import { ActionTree } from "vuex";
import { SurveyActionsTypes, SurveyMutationsTypes } from "./types";
import { Survey, SurveyActions, SurveyState } from "./interface";
import Client from "@/plugins/axios/axios";
import { Response_ } from "@/plugins/axios/response";

export const actions: ActionTree<SurveyState, SurveyState> & SurveyActions = {
  [SurveyActionsTypes.LIST_SURVEY]: async ({ commit }): Promise<number> => {
    return Client.get<number, Response_>(`survey/list`)
      .then((response: Response_) => {
        commit(SurveyMutationsTypes.SET_SURVEY, response.body as Array<Survey>);
        return response.status;
      })
      .catch((err) => err);
  },
  [SurveyActionsTypes.CREATE_SURVEY]: async ({ commit }, survey_date: FormData): Promise<Response_> => {
    return Client.post<Response_, Response_>(`survey/`, survey_date)
      .then((response) => {
        commit(SurveyMutationsTypes.CREATE_SURVEY, response.body as Survey);
        return response;
      })
      .catch((err) => err);
  },
  [SurveyActionsTypes.UPDATE_SURVEY]: async (
    { commit },
    { survey_data: survey_data, _id: _id }
  ): Promise<Response_> => {
    delete survey_data._id;
    return Client.put<Response_, Response_>(`survey/${_id}`, survey_data)
      .then((response) => {
        commit(SurveyMutationsTypes.UPDATE_SURVEY, response.body as Survey);
        return response;
      })
      .catch((err) => err);
  }
};
